<div role="main" class="main">

  <section class="page-header">
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <ul class="breadcrumb">
            <li><a href="#">Anasayfa</a></li>
            <li class="active">Yazılım / Proje</li>
          </ul>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <h1>Yazılım / Proje</h1>
        </div>
      </div>
    </div>
  </section>

  <div class="container">

    <h2><strong>Intes Technology</strong> ile proje süreci</h2>

    <div class="row">
      <div class="col-md-12">
        <p class="lead">
          Projelerinizi geliştirirken, öncelikle projeye konu tüm iş süreçlerinizi detaylıca inceliyoruz. Sonrasında proje kapsamındaki taleplerinizi alıyoruz. Böylece projenin genişleme çevresini de hesap edebiliyoruz. Bu bilgiler ışığında, deneyimlerimiz ile isteklerinizi birleştirerek yaptığımız çalışmalar ile <strong>işinize en uygun ürünü</strong> ortaya çıkarıyoruz.
        </p>
      </div>
    </div>

    <hr>

    <div class="row">
      <div class="col-md-6">
        <div class="toggle toggle-primary mt-lg" data-plugin-toggle>
          <section class="toggle" style="font-size: 14pt !important;">
            <label>Android Proje Geliştirme</label>
            <div class="toggle-content" style="font-size: 13pt !important;">

                        <p class="lead">
                           Android için en efektif çözüm olan native uygulama geliştirmeyi tercih ediyoruz. Özel talepleriniz doğrultusunda <strong>Kotlin yada Java</strong> ile geliştirmeleri yapıyoruz.
                        </p>

                        <p class="lead">
                           Native çözümler sağlamamıza rağmen, deneyimlerimiz ile oluşturduğumuz altyapımız sayesinde, ios ve android platformlarında istenen ikinci platformdaki uygulamayı normal sürenin <strong>% 20</strong> süresinde bitirebiliyoruz.
                        </p>

                             <input class="btn btn-primary mb-xl" (click)="changeService(7)" data-toggle="modal" data-target="#exampleModal" type="button"  [value]="checkServicePrice(7)">
            </div>
          </section>
                  <section class="toggle" style="font-size: 14pt !important;">
                     <label>Ios Proje Geliştirme</label>
                     <div class="toggle-content" style="font-size: 13pt !important;">

                        <p class="lead">
                           Ios için en efektif çözüm olan native uygulama geliştirmeyi tercih ediyoruz. En güncel teknoloji ve dil olan <strong>Swift</strong> ile geliştirmeleri yapıyoruz.
                        </p>

                        <p class="lead">
                           Native çözümler sağlamamıza rağmen, deneyimlerimiz ile oluşturduğumuz altyapımız sayesinde, ios ve android platformlarında istenen ikinci platformdaki uygulamayı normal sürenin <strong>% 20</strong> süresinde bitirebiliyoruz.
                        </p>



                        <ul>


                        </ul>

                             <input class="btn btn-primary mb-xl" type="button" (click)="changeService(11)" data-toggle="modal" data-target="#exampleModal"  [value]="checkServicePrice(11)">
                     </div>
                  </section>
                  <section class="toggle" style="font-size: 14pt !important;">
                     <label>Web Proje Geliştirme</label>
                     <div class="toggle-content" style="font-size: 13pt !important;">

                        <p class="lead">
                           Web geliştirmelerimizde isteğinize ve sisteminize uygun çözümler üretiyoruz. Bunun için öncelikle isteğinizle birlikte projenin çalışacağın sistemin de detaylarını inceleyip en uygun şekilde geliştirmeler yapıyoruz.
                        </p>

                        <p class="lead">
                           Deneyimlerimizle ihtiyaçlarınızı en üst düzeyde karşılayan arayüz çalışmalarımız ile çok esnek ve kullanışlı bir deneyim sunuyoruz.
                        </p>

                        <div class="lead">
                           <strong>Kullandığımız teknolojiler</strong>
                           <ul>
                           <li>.Net Core</li>
                           <li>.Net MVC</li>
                           <li>Sql Server</li>
                           <li>MySql</li>
                           <li>Angular</li>
                        </ul>
                        </div>

                        <ul>
                    </ul>

                      <input class="btn btn-primary mb-xl" type="button" (click)="changeService(12)" data-toggle="modal" data-target="#exampleModal"   [value]="checkServicePrice(12)">
                     </div>
                  </section>
        </div>
      </div>
      <div class="col-md-6">
        <div class="featured-box featured-box-primary">
          <div class="box-content" style="font-size: 14pt !important;">
            <h4 >Sağladığımız hizmetler ve proje ilerleme süreci</h4>
            <hr>

            <ul class="list list-icons align-left" style="font-size: 13pt !important;">
                        <li><i class="fa fa-check"></i> <strong>İstek Analizi :</strong> İsteğinizi detaylıca inceliyor ve tüm bilinmezlikleri ortadan kaldırarak en başta net olarak anlaşma sağlıyoruz.</li>
                        <li><i class="fa fa-check"></i> <strong>Tasarım :</strong> Tasarım işimiz değil. Ancak isteğiniz halinde mobil proje ise mobil platformlarda, web ise web platformunda deneyimli, anlaşmalı firma/kişilerden tasarımlarınızı yaptırmak için aracı olabiliriz. Bu süreçte uygulama akışı da tasarımcıya tarafımızdan aktarılır ve işleve uygun tasarımlar ortaya çıkar.</li>
                        <li><i class="fa fa-check"></i> <strong>Geliştirme :</strong> Deneyimli yazılımcılarımız projenizi en doğru şekilde kodlar.</li>
                        <li><i class="fa fa-check"></i> <strong>Scrum Proje Yönetimi :</strong> Projenizi sizinle birlikte belirleyeceğimiz zaman aralıkları ile ilerleyişini canlı olarak takip edebilir ve bizzat test edebilirsiniz.</li>
                        <li><i class="fa fa-check"></i> <strong>Test :</strong> Her bir modül sonrasında test ekibimiz uygulamanın akışını ve çalışmasını test eder.</li>
                        <li><i class="fa fa-check"></i> <strong>Kullanıcı Testi :</strong> Uygulama sizin isteğinize göre test edilebilir hale geldiğinde, sizin belirleyeceğiniz, işinize hakim kişiler tarafından kontrol edilir.</li>
            </ul>

          </div>
        </div>
      </div>
    </div>

  </div>

</div>


<div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true" tabindex="-1" role="dialog">
  <div class="modal-dialog modal-lg" style="width: 96%;" role="document" >
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{{selectedService.price>0? selectedService?.name +" Satın Al":selectedService.name+" Görüşme Talebi"}}   </h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">

					<div class="row" *ngIf="IsFree">
						<div class="col-md-12">

							<h2 class="mb-sm mt-sm"><strong>Sizinle</strong> iletişime geçelim</h2>
								<div class="row">
									<div class="form-group">
										<div class="col-md-6">
											<label>Ad Soyad *</label>
											<input type="text" [(ngModel)]="contact.name" data-msg-required="Lütfen adınızı giriniz." maxlength="100" class="form-control" name="name" id="name" required>
										</div>
										<div class="col-md-6">
											<label>E-Posta *</label>
											<input type="email" [(ngModel)]="contact.email"  data-msg-required="Lütfen E-Posta adresinizi giriniz." data-msg-email="Lütfen geçerli bir Email adresi giriniz." maxlength="100" class="form-control" name="email" id="email" required>
										</div>
									</div>
								</div>
								<div class="row">
									<div class="form-group">
										<div class="col-md-12">
											<label>Telefon</label>
											<input type="number" [(ngModel)]="contact.phone" onkeydown="return (event.keyCode !== 69 && $(this).val().length<13)"  maxlength="15" class="form-control" name="phone" id="phone">
										</div>
									</div>
								</div>
								<div class="row">
									<div class="form-group">
										<div class="col-md-12">
											<label>Konu</label>
											<input type="text" [(ngModel)]="contact.subject"  data-msg-required="Lütfen konu giriniz." maxlength="100" class="form-control" name="subject" id="subject" required>
										</div>
									</div>
								</div>
								<div class="row">
									<div class="form-group">
										<div class="col-md-12">
											<label>Mesaj *</label>
											<textarea maxlength="5000" [(ngModel)]="contact.message"  data-msg-required="Lütfen mesajınızı giriniz." rows="10" class="form-control" name="message" id="message" required></textarea>
										</div>
									</div>
								</div>
						</div>
          </div>

          <div *ngIf="!IsFree">
            <div class="row">
              <div class="col-md-12">
                <h2 class="mb-sm mt-sm"><strong>Detayları belirtip</strong> satın almayı yapınız</h2>
                  <div class="row">
                    <div class="form-group">
                      <div class="col-md-12">
                        <label for="productName" class="col-md-2 col-xs-12"><strong>Talep Edilen Ürün :</strong></label>
                        <input disabled="true" style="width:40%;"  class="col-md-3 col-xs-12"  value="{{serviceRegistration.serviceName}}"  name="productName" id="productName">
                      </div>
                    </div>
                  </div>


                  <div class="row" *ngIf="selectedService?.educationDate.length>0" style="padding-left: 15px;">
                    <div class="form-group">
                        <label for="sorting-dropdown2"  class="col-md-2 col-xs-12"><strong>Detay :</strong></label>

                            <select style="padding-left: 3px;" class="col-md-9 col-xs-12" [(ngModel)]="serviceRegistration.calendarId"  (ngModelChange)="ChangeDate($event)" id="sorting-dropdown2">
                              <option *ngFor="let item of selectedService.educationDate" [value]="item.id" title="{{item.date}}" data-sorting="True">{{item.date}}</option>
                            </select>
                    </div>
                  </div>

                  <div class="row" style="padding-left: 15px;">
                    <div class="form-group">
                          <label for="unitPrice"  class="col-md-2 col-xs-12"><strong>Birim fiyat : </strong></label>
                          <input disabled="true" style="padding-left: 3px;"  class="col-md-2 col-xs-12" value="{{serviceRegistration.price |  currency: 'TRY':'':''}} TL"  name="unitPrice" id="unitPrice">
                    </div>
                  </div>
                  <div class="row" style="padding-left: 15px;">

                    <div class="form-group">
                        <label for="sorting-dropdown"  class="col-md-2 col-xs-12"><strong>Miktar : </strong></label>
                        <select  class="col-md-1 col-xs-12" [(ngModel)]="serviceRegistration.quantity"  (ngModelChange)="ChangeQuantity($event)" id="sorting-dropdown">
                          <option [value]="1" data-sorting="True">1</option>
                          <option [value]="2" data-sorting="True">2</option>
                          <option [value]="3" data-sorting="True">3</option>
                          <option [value]="4" data-sorting="True">4</option>
                          <option [value]="5" data-sorting="True">5</option>
                          <option [value]="10" data-sorting="True">10</option>
                        </select>
                    </div>
                  </div>

                <div class="panel panel-default col-lg-12 col-md-12 col-sm-12 col-xs-12" style="margin-right: 30px;">
                  <div class="panel-heading">
                    <h4 class="panel-title"><i class="fa fa-user"></i>  İletişim Bilgisi </h4>
                  </div>
                    <div class="panel-body">
                      <fieldset id="account">
                      <div class="row">
                        <div class="form-group ">
                          <div class="form-group required paddinginput col-md-4 col-lg-4 col-sm-12 col-xs-12">
                            <label for="input-payment-firstname" class="control-label">Adınız ve Soyadınız *</label>
                            <input type="text" class="form-control" [(ngModel)]="serviceRegistration.name" id="input-payment-firstname"  placeholder="Adınız ve Soyadınız " name="firstname">
                          </div>
                          <div class="form-group required paddinginput col-md-4 col-lg-4 col-sm-12 col-xs-12">
                            <label>E-Posta *</label>
                            <input type="email" [(ngModel)]="serviceRegistration.email" value="" data-msg-required="Lütfen E-Posta adresinizi giriniz." placeholder="Email Adresi" data-msg-email="Lütfen geçerli bir Email adresi giriniz." maxlength="100" class="form-control" name="email" id="email" required>
                          </div>
                        <div class="form-group required paddinginput col-md-4 col-lg-4 col-sm-12 col-xs-12">
                          <label for="input-payment-telephone" class="control-label">Telefon Numarası *</label>
                          <input type="number" class="form-control" [(ngModel)]="serviceRegistration.phone" onkeydown="return (event.keyCode !== 69 && $(this).val().length<13)" id="input-payment-telephone" placeholder="Telefon Numarası"  name="Vergi">
                        </div>
                      </div>
                    </div>

                        <div class="row">
                          <div class="form-group">
                            <div class="col-md-12">
                              <label>Detaylar (Belirtmek istediğiniz detayları buraya yazabilirsiniz)</label>
                              <textarea maxlength="5000" [(ngModel)]="serviceRegistration.message" data-msg-required="Lütfen mesajınızı giriniz." rows="5" class="form-control" name="message" id="detail"></textarea>
                            </div>
                          </div>
                        </div>
                      </fieldset></div></div>
                  <div class="panel panel-default col-lg-12 col-md-12 col-sm-12 col-xs-12" style="margin-right: 30px;">
                    <div class="panel-heading">
                      <h4 class="panel-title"><i class="fa fa-user"></i>  Fatura Bilgisi </h4>
                    </div>
                      <div class="panel-body">

                        <div class="row" style="text-align: center;padding-bottom: 3%;">
                          <button type="button" (click)="CompanyChange(true)" class="btn btn-primary"  [ngClass]="{'btnclr': serviceRegistration.isCompany}" ><span class="fa fa-building" style="padding-right:10px"></span> Kurumsal</button>
                          <button type="button" (click)="CompanyChange(false)" class="btn btn-primary" style="margin-left: 5%" [ngClass]="{'btnclr': !serviceRegistration.isCompany}"  ><span class="fa fa-user" style="padding-right:10px"></span> Bireysel</button>
                      </div>
                        <fieldset id="account">

                          <div class="row">
                                <div class="form-group required paddinginput col-md-12 col-lg-12 col-sm-12 col-xs-12">
                                  <label for="input-payment-firstname" class="control-label">{{serviceRegistration.isCompany?"Firma Adı *":"Adınız ve Soyadınız *"}}</label>
                                  <input type="text" class="form-control" [(ngModel)]="serviceRegistration.taxName" id="input-payment-firstname"  placeholder="{{serviceRegistration.isCompany?'Firma Adı':'Adınız ve Soyadınız'}}" name="firstname">
                              </div>


                          </div>
                            <div *ngIf="serviceRegistration.isCompany" class="form-group required paddinginput col-md-12 col-lg-12 col-sm-12 col-xs-12" style="    padding: 0px;">
                              <label for="input-payment-telephone" class="control-label">Vergi Dairesi *</label>
                              <div class="ng-autocomplete">
                                <ng-autocomplete
                                  [(ngModel)]="taxCompany"
                                  [data]="taxOffices"
                                  [placeHolder]="'Vergi Dairesi Seçin'"
                                  [searchKeyword]="'name'"
                                  (inputChanged)='onChangeSearch($event)'
                                  [itemTemplate]="itemTemplate"
                                  [notFoundTemplate]="notFoundTemplate">
                                </ng-autocomplete>

                                <ng-template #itemTemplate let-item>
                                <a [innerHTML]="item.name"></a>
                                </ng-template>

                                <ng-template #notFoundTemplate let-notFound>
                                <div [innerHTML]="notFound"></div>
                                </ng-template>
                                </div>
                            </div>
                            <div class="form-group required paddinginput col-md-12 col-lg-12 col-sm-12 col-xs-12" style="    padding: 0px;">
                              <label for="input-payment-telephone" class="control-label">{{serviceRegistration.isCompany?"Vergi Numarası *":"TC Numarası *"}}</label>
                              <input type="number"   class="form-control" onkeydown="return (event.keyCode !== 69 && $(this).val().length<12)"   [(ngModel)]="serviceRegistration.taxNumberOrTC" id="input-payment-telephone" placeholder="{{serviceRegistration.isCompany?'Vergi Numarası *':'TC Numarası *'}}"  name="Vergi">
                            </div>
                            <div class="row">
                              <div  class="form-group required  col-md-6 col-xl-6 col-sm-12 col-xs-12">
                                <label for="input-payment-telephone" class="control-label">İl *</label>
                                <select  [ngModel]="serviceRegistration.cityId" name="make" (ngModelChange)="ChangeCity($event)"  id="so_make0" class="form-control">
                                  <option [value]="0" selected="">Şehir Seçin</option>
                                  <option [value]="i.id" *ngFor="let i of city">{{i.name}}</option>
                                </select>
                              </div>
                              <div class="form-group required  col-md-6 col-xl-6 col-sm-12 col-xs-12">
                                <label for="input-payment-telephone" class="control-label">İlçe *</label>
                                <select [disabled]="serviceRegistration.cityId==0"  [ngModel]="serviceRegistration.townId" name="make" (ngModelChange)="ChangeCounty($event)"  id="so_make0" class="form-control">
                                  <option [value]="i.id" *ngFor="let i of town">{{i.name}}</option>
                                </select>
                              </div>
                            </div>
                          <div class="form-group required paddinginput col-md-12 col-lg-12 col-sm-12 col-xs-12" style="    padding: 0px;">
                            <label for="input-payment-telephone" class="control-label">Adres *</label>
                             <textarea rows="2" class="form-control" [(ngModel)]="serviceRegistration.address" id="confirm_comment" name="Adres"></textarea>
                          </div>

                        </fieldset>
                        </div>
                    </div>
                  <br/>
                  <div class="checkbox-custom checkbox-default col-md-12 col-lg-12 col-sm-12 col-xs-12">
                    <input [(ngModel)]="Agreement" type="checkbox" id="acceptcontract" value="1">
                    <label style="padding-left: 5px;" for="acceptcontract"><a target="_blank" href="/distance-selling-contract">Mesafeli Satış Sözleşmesi</a>ni okudum onaylıyorum.</label>
                  </div>
                  <br/>
              </div>
            </div>
          </div>

      </div>
      <div class="row" style="padding-left: 5%;" *ngIf="selectedService?.note?.length>0">
        <p class="badge badge-success">  Not: {{selectedService?.note}}</p>
       </div>
      <div class="modal-footer">
        <input *ngIf="IsFree" type="button" value="Gönder" (click)="sendContact()" class="btn btn-primary btn-lg mb-xlg" id="send" data-loading-text="Gönderiliyor...">
        <input *ngIf="!IsFree"  [disabled]="!buyButtonActive" type="button" [value]="buttonText"  (click)="sendRegisteration()" class="btn btn-primary btn-lg mb-xlg" id="send" data-loading-text="Gönderiliyor...">
        <button type="button" class="btn btn-secondary btn-lg mb-xlg" data-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>
